package pl.mothdigital.neuronowi.pages.specialists

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobweb.silk.components.graphics.*
import com.varabyte.kobweb.silk.components.icons.fa.*
import com.varabyte.kobweb.silk.components.layout.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.css.keywords.*
import org.jetbrains.compose.web.dom.*
import pl.mothdigital.neuronowi.common.resources.*
import pl.mothdigital.neuronowi.components.*
import pl.mothdigital.neuronowi.components.layouts.*
import pl.mothdigital.neuronowi.components.sections.cta.*
import pl.mothdigital.neuronowi.components.text.*
import pl.mothdigital.neuronowi.components.widgets.*
import pl.mothdigital.neuronowi.common.utils.fixPolishOrphans
import pl.mothdigital.neuronowi.theme.*
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import org.jetbrains.compose.web.css.FlexWrap
import com.varabyte.kobweb.compose.css.AlignItems
import pl.mothdigital.neuronowi.common.model.SpecialistData

private val priceItems = listOf(
    PriceItem(
        StringResources.JULIA_SIUTA_PRICE_1_NAME,
        StringResources.JULIA_SIUTA_PRICE_1_TIME,
        StringResources.JULIA_SIUTA_PRICE_1_AMOUNT
    ),
    PriceItem(
        StringResources.JULIA_SIUTA_PRICE_2_NAME,
        StringResources.JULIA_SIUTA_PRICE_2_TIME,
        StringResources.JULIA_SIUTA_PRICE_2_AMOUNT
    ),
    PriceItem(
        StringResources.JULIA_SIUTA_PRICE_3_NAME,
        StringResources.JULIA_SIUTA_PRICE_3_TIME,
        StringResources.JULIA_SIUTA_PRICE_3_AMOUNT
    ),
    PriceItem(
        StringResources.JULIA_SIUTA_PRICE_4_NAME,
        StringResources.JULIA_SIUTA_PRICE_4_TIME,
        StringResources.JULIA_SIUTA_PRICE_4_AMOUNT
    ),
    PriceItem(
        StringResources.JULIA_SIUTA_PRICE_5_NAME,
        StringResources.JULIA_SIUTA_PRICE_5_TIME,
        StringResources.JULIA_SIUTA_PRICE_5_AMOUNT
    )
)

@Page
@Composable
fun JuliaSiutaPage() {
    SpecialistPageLayout(
        title = StringResources.JULIA_SIUTA,
        headerSection = { HeaderSection() },
        profileSection = { ProfileSection() },
        workAreasSection = { WorkAreasSection() },
        specializationsSection = { SpecializationsSection() },
        servicesSection = { ServicesSection() },
        priceSection = { PriceSection() },
        ctaSection = { context ->
            CTASection(
                ctx = context,
                customAction = { js("window.scrollTo({ top: 0, behavior: 'smooth' })") },
            )
        },
    )
}

@Composable
private fun HeaderSection() {
    Section(
        attrs = Modifier
            .fillMaxWidth()
            .padding(topBottom = 3.cssRem, leftRight = 6.percent)
            .backgroundColor(SiteTheme.green._50)
            .toAttrs()
    ) {
        Column(
            modifier = Modifier.fillMaxWidth().margin { auto },
            verticalArrangement = Arrangement.spacedBy(1.cssRem)
        ) {
            AppH1 { Text(StringResources.JULIA_SIUTA.fixPolishOrphans()) }
            AppP(color = SiteTheme.green._800, modifier = Modifier.fontSize(1.25.cssRem)) {
                Text(StringResources.JULIA_SIUTA_ACADEMIC_TITLES.fixPolishOrphans())
            }
            AppP(
                color = SiteTheme.green._800,
                modifier = Modifier.fontSize(1.25.cssRem).fontWeight(FontWeight.Bold)
            ) {
                Text(StringResources.JULIA_SIUTA_PHONE_NUMBER)
            }
        }
    }
}

@Composable
private fun ProfileSection() {
    Section(
        attrs = Modifier
            .fillMaxWidth()
            .padding(topBottom = 3.cssRem, leftRight = 6.percent)
            .toAttrs()
    ) {
        // Large screens: side-by-side image and text
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .flexWrap(FlexWrap.Wrap)
                .displayIfAtLeast(Breakpoint.LG)
                .gap(3.cssRem),
        ) {
            Image(
                src = ImageResources.avatarJuliaSiuta.src,
                alt = ImageResources.avatarJuliaSiuta.description,
                modifier = Modifier
                    .width(400.px)
                    .borderRadius(1.cssRem)
                    .boxShadow(blurRadius = 8.px, color = SiteTheme.black._100)
            )
            Column(
                modifier = Modifier
                    .flex(1)
                    .gap(1.5.cssRem)
                    .padding(1.cssRem),
            ) {
                AppH2 { Text("O mnie") }
                AppP(modifier = Modifier.textAlign(TextAlign.Justify)) { Text(StringResources.JULIA_SIUTA_ABOUT_ME_1.fixPolishOrphans()) }
                AppP(modifier = Modifier.textAlign(TextAlign.Justify)) { Text(StringResources.JULIA_SIUTA_ABOUT_ME_2.fixPolishOrphans()) }
                AppP(modifier = Modifier.textAlign(TextAlign.Justify)) { Text(StringResources.JULIA_SIUTA_ABOUT_ME_3.fixPolishOrphans()) }
            }
        }
        // Medium and smaller: image above text
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .alignItems(AlignItems.Center)
                .displayUntil(Breakpoint.LG)
                .gap(1.5.cssRem)
                .padding(1.cssRem),
        ) {
            AppH2 { Text("O mnie") }
            AppP(modifier = Modifier.textAlign(TextAlign.Justify)) { Text(StringResources.JULIA_SIUTA_ABOUT_ME_1.fixPolishOrphans()) }
            AppP(modifier = Modifier.textAlign(TextAlign.Justify)) { Text(StringResources.JULIA_SIUTA_ABOUT_ME_2.fixPolishOrphans()) }
            AppP(modifier = Modifier.textAlign(TextAlign.Justify)) { Text(StringResources.JULIA_SIUTA_ABOUT_ME_3.fixPolishOrphans()) }
            Image(
                src = ImageResources.avatarJuliaSiuta.src,
                alt = ImageResources.avatarJuliaSiuta.description,
                modifier = Modifier
                    .widthIn(min = 300.px, max = 500.px)
                    .fillMaxWidth()
                    .borderRadius(1.cssRem)
                    .boxShadow(blurRadius = 8.px, color = SiteTheme.black._100)
            )
        }
    }
}

@Composable
private fun WorkAreasSection() {
    Section(
        attrs = Modifier
            .fillMaxWidth()
            .padding(topBottom = 3.cssRem, leftRight = 6.percent)
            .toAttrs()
    ) {
        Column(modifier = Modifier.fillMaxWidth().margin { auto }.gap(2.cssRem)) {
            AppH2 { Text(StringResources.JULIA_SIUTA_WORK_AREAS_TITLE.fixPolishOrphans()) }
            val workAreas = listOf(
                StringResources.JULIA_SIUTA_WORK_AREA_1,
                StringResources.JULIA_SIUTA_WORK_AREA_2,
                StringResources.JULIA_SIUTA_WORK_AREA_3,
                StringResources.JULIA_SIUTA_WORK_AREA_4,
                StringResources.JULIA_SIUTA_WORK_AREA_5,
                StringResources.JULIA_SIUTA_WORK_AREA_6,
            )
            Ul {
                workAreas.forEach { area ->
                    Li { Text(area.fixPolishOrphans()) }
                }
            }
        }
    }
}

@Composable
private fun SpecializationsSection() {
    val specializations = listOf(
        SpecialistData(
            icon = { FaHeart() },
            title = StringResources.JULIA_SIUTA_SPEC_PSYCHOLOGIA_TITLE,
            description = StringResources.JULIA_SIUTA_SPEC_PSYCHOLOGIA_DESC
        ),
        SpecialistData(
            icon = { FaUsers() },
            title = StringResources.JULIA_SIUTA_SPEC_TUS_TITLE,
            description = StringResources.JULIA_SIUTA_SPEC_TUS_DESC
        ),
        SpecialistData(
            icon = { FaBrain() },
            title = StringResources.JULIA_SIUTA_SPEC_EMOCJE_TITLE,
            description = StringResources.JULIA_SIUTA_SPEC_EMOCJE_DESC
        )
    )
    Section(
        attrs = Modifier
            .fillMaxWidth()
            .padding(topBottom = 3.cssRem, leftRight = 6.percent)
            .backgroundColor(SiteTheme.green._50.toRgb().copy(alpha = 128))
            .toAttrs()
    ) {
        Column(modifier = Modifier.fillMaxWidth().margin { auto }.gap(2.cssRem)) {
            AppH2 { Text(StringResources.JULIA_SIUTA_SPECIALIZATIONS_TITLE.fixPolishOrphans()) }
            SimpleGrid(
                modifier = Modifier.fillMaxWidth().gap(1.5.cssRem),
                numColumns = numColumns(base = 1, sm = 1, md = 2, lg = 2, xl = 2)
            ) {
                specializations.forEach { info ->
                    SpecialistInfoCard(
                        icon = info.icon,
                        title = info.title,
                        description = info.description
                    )
                }
            }
        }
    }
}

@Composable
private fun ServicesSection() {
    Section(
        attrs = Modifier
            .fillMaxWidth()
            .padding(topBottom = 3.cssRem, leftRight = 6.percent)
            .toAttrs()
    ) {
        Column(modifier = Modifier.fillMaxWidth().margin { auto }.gap(2.cssRem)) {
            AppH2 { Text(StringResources.JULIA_SIUTA_SERVICES_TITLE.fixPolishOrphans()) }
            val services = listOf(
                StringResources.JULIA_SIUTA_SERVICE_1,
                StringResources.JULIA_SIUTA_SERVICE_2,
                StringResources.JULIA_SIUTA_SERVICE_3,
                StringResources.JULIA_SIUTA_SERVICE_4,
            )
            Ul {
                services.forEach { service ->
                    Li { Text(service.fixPolishOrphans()) }
                }
            }
        }
    }
}

@Composable
private fun PriceSection() {
    Section(
        attrs = Modifier
            .fillMaxWidth()
            .padding(topBottom = 3.cssRem, leftRight = 6.percent)
            .backgroundColor(SiteTheme.green._50.toRgb().copy(alpha = 128))
            .toAttrs()
    ) {
        Column(modifier = Modifier.fillMaxWidth().margin { auto }.gap(2.cssRem)) {
            AppH2 { Text(StringResources.JULIA_SIUTA_PRICE_TITLE.fixPolishOrphans()) }

            SpecialistPriceTable(priceItems = priceItems)

            AppP(modifier = Modifier.fontSize(0.9.cssRem), color = SiteTheme.black._700) {
                Text(StringResources.JULIA_SIUTA_PRICE_NOTE.fixPolishOrphans())
            }
        }
    }
}
